import ContactCardTop from "./ContactCardTop";
import StatusBadge from './StatusBadge';

import { BookDashed } from 'lucide-react';

const ContactCard = ({ selectedContact, setContactCalled, selectedList, uid, setContacts, setShowContact, setShowEditContact, menu }) => {
  const dateFormatOptions = {
    weekday: "short",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric"
  };

  return (
    <>
      <ContactCardTop
        selectedContact={selectedContact}
        setContactCalled={setContactCalled}
        uid={uid}
        selectedList={selectedList}
        setContacts={setContacts}
        setShowContact={setShowContact}
        setShowEditContact={setShowEditContact}
        menu={menu}
      />
      {selectedContact.notes.length > 0 ?
        <ul className='call-history'>
          {[...selectedContact.notes].reverse().map((note) => {
            return (
              <li className='call-history-entry' key={note.noteDate.seconds}>
                <StatusBadge status={note.status} />
                <div>{note.noteText || "No note"}</div>
                <div className='entry-date'>{new Date(note.noteDate.seconds * 1000).toLocaleTimeString("en-US", dateFormatOptions).replace(" at ", ' • ')}</div>
              </li>
            )
          })}
        </ul>
        :
        <div className='call-history-empty'>
          <BookDashed size={"10rem"} strokeWidth={1} color={"var(--neutral-300)"} />
          <div>
            <div>No call notes</div>
            <div>Call this contact and save a note to view it here.</div>
          </div>
        </div>
      }
    </>
  );
}

export default ContactCard;